import React from "react";
import { motion } from "framer-motion";

const offices = [
  {
    key: "dubai",
    title: "Offices in Dubai",
    city: "Dubai",
    address: [
      "Reef Tower,",
      "Jumeirah Lake Tower, Cluster O",
      "Dubai, UAE",
      "Tel: +971 (0)452 94626",
    ],
    img: "DubaiOffice.png",
    alt: "Dubai Office",
    focus: "top",
  },
  {
    key: "london",
    city: "London",
    address: [
      "16 Great Queen Street,",
      "Covent Garden,",
      "London, United Kingdom",
      "WC2B 5AH",
      "Tel: +44 (0)208 308 9364",
    ],
    img: "LondonOffice.png",
    alt: "London Office",
    focus: "center",
  },
  {
    key: "newyork",
    city: "New York",
    address: [
      "1 Little W 12th St,",
      "New York, NY 10014,",
      "United States",
      "Tel: +1 (0)845 409 0628",
    ],
    img: "NewYorkOffice.png",
    alt: "New York Office",
    focus: "right-center",
  },
];

const focusClass = (focus?: string) => {
  switch (focus) {
    case "top":
      return "object-[50%_35%]";
    case "right-center":
      return "object-[70%_50%]";
    case "left-center":
      return "object-[30%_50%]";
    case "bottom":
      return "object-bottom";
    case "left":
      return "object-left";
    case "right":
      return "object-right";
    default:
      return "object-center";
  }
};

const containerVariants = { hidden: {}, show: { transition: { staggerChildren: 0.12 } } };
const cardVariants = { hidden: { opacity: 0, y: 30 }, show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } } };

const OfficesSection = () => {
  const base = `${process.env.PUBLIC_URL || ""}/images/stockimages`;

  return (
    <section className="w-full py-20 bg-white font-sans">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <h2
          className="text-4xl md:text-5xl font-bold text-center mb-12"
          style={{ fontFamily: "Inter, sans-serif" }}
        >
          Global Reach, Local Expertise
        </h2>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10"
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
        >
          {offices.map((o) => (
            <motion.article
              key={o.key}
              className="rounded-2xl"
              variants={cardVariants}
              whileHover={{ scale: 1.02, boxShadow: "0 8px 32px rgba(0,0,0,0.08)" }}
            >
              {/* Taller frame via fixed heights */}
              <div className="relative w-full h-64 sm:h-72 md:h-80 lg:h-96 xl:h-[28rem] rounded-2xl overflow-hidden shadow-md">
                <img
                  src={`${base}/${o.img}`}
                  alt={o.alt}
                  loading="lazy"
                  decoding="async"
                  className={`absolute inset-0 w-full h-full object-cover ${focusClass(o.focus)}`}
                />
              </div>

              <div className="mt-5">
                <h3 className="text-2xl md:text-3xl font-semibold">{o.title || o.city}</h3>
                <div className="text-gray-700 text-base mt-2 leading-6">
                  {o.address.map((line, idx) => (
                    <div key={idx}>{line}</div>
                  ))}
                </div>
              </div>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default OfficesSection;
